import React from "react";

export const Simbologia = () => {
  return (
    <div className="w-[600px] h-[60px] bottom-2 left-[50%] transform -translate-x-1/2  absolute bg-[rgba(255,255,255,.6)] rounded-[15px] flex items-center justify-center px-2">
      <div className="flex flex-1 items-center justify-center">
        <img src="http://maps.google.com/mapfiles/ms/icons/yellow.png"></img>
        <p className="text-sm">Tienda con Registros</p>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <img src="http://maps.google.com/mapfiles/ms/icons/red.png"></img>
        <p className="text-sm">Tienda sin registros</p>
      </div>
      <div className="flex flex-1 items-center justify-center">
        <img src="http://maps.google.com/mapfiles/ms/icons/green.png"></img>
        <p className="text-sm">Tiendas Seleccionadas</p>
      </div>
    </div>
  );
};

// <div className="flex flex-1 items-center justify-center">
//           <img src="http://maps.google.com/mapfiles/ms/icons/blue.png"></img>
//           <p className="text-sm">Tienda completa (futura)</p>
//         </div>
//         <div className="flex flex-1 items-center justify-center">
//           <img src="http://maps.google.com/mapfiles/ms/icons/green.png"></img>
//           <p className="text-sm">Tiendas Seleccionadas</p>
//         </div>
//         <div className="flex flex-1 items-center justify-center">
//           <img src="http://maps.google.com/mapfiles/ms/icons/green.png"></img>
//           <p className="text-sm">Clustering Tiendas</p>
//         </div>
